import {HIDE_ALERT} from "../../../constants/PlayerConstants";
import {GeneralAction, HidePlayerPayload} from "../../../@types/actions";

export const HideAlertAction = (data: HidePlayerPayload): GeneralAction<HidePlayerPayload> => ({
    type: HIDE_ALERT,
    payload: data
});
